import {IAllClientsAPIResponse, ICustomerTypesAPIResponse, IWebAppVersionResponse } from './clientsSlice';
import { HttpRequest } from '../../../util/http';


export const getAllClients = (allClientStatus) => {
  return new Promise<IAllClientsAPIResponse>((resolve) => {
    const method = 'POST';
    const data = {
      status: allClientStatus,
    };

    HttpRequest.fetch<IAllClientsAPIResponse>('/scripts/clients/get_all', {
      data,
      method,
    }).then((res) => resolve(res));
  });
};

export const getAllCustomerTypes = () => {
  return new Promise<ICustomerTypesAPIResponse>((resolve) => {
    HttpRequest.fetch<ICustomerTypesAPIResponse>(
      '/scripts/customer_type/get_all'
    ).then((res) => resolve(res));
  });
};

export const getWebAppVersion = () => {
  return new Promise<IWebAppVersionResponse>((resolve) => {
    HttpRequest.fetch<IWebAppVersionResponse>(
      '/scripts/clients/getWebappVersion'
    ).then((res) => resolve(res));
  });
};





